import { AnnouncementErrorTypeEnum } from "../../entities/enums";

export const getAnnouncementErrorClassName = (errorType: AnnouncementErrorTypeEnum) => {
    switch (errorType) {
      case AnnouncementErrorTypeEnum.AnnouncementOutOfDate:
      case AnnouncementErrorTypeEnum.IncorrectSheetId:
      case AnnouncementErrorTypeEnum.Exception:
        return "text-gray-700";
      case AnnouncementErrorTypeEnum.DocumentLoadingFailed:
      case AnnouncementErrorTypeEnum.ScrappingFailed:
      case AnnouncementErrorTypeEnum.ValidationError:
      case AnnouncementErrorTypeEnum.CreateError:
      case AnnouncementErrorTypeEnum.UpdateError:
      case AnnouncementErrorTypeEnum.MonthlyCacheRefreshFailed:
        return "text-red-500";
      case AnnouncementErrorTypeEnum.ValidationWarning:
      case AnnouncementErrorTypeEnum.UnknownSymbol:
      case AnnouncementErrorTypeEnum.IncorrectActivityField:
      case AnnouncementErrorTypeEnum.ObjectDeleted:
      case AnnouncementErrorTypeEnum.MonthlyCacheRefreshPending:
        return "text-yellow-500";
      default:
        return undefined;
    }
  };